// There is two image origins: MediaServer and Sitecore. Components will have to set from which origin the image will come
// If not set by default it will generate images for MediaServer
export enum ImageOrigin {
  MediaServer = 'MediaServer',
  CMSSitecore = 'CMSSitecore',
}

export function buildImgSrc(url: string, width: number, height?: number, imageOrigin: ImageOrigin = ImageOrigin.MediaServer): string {
  const normalizedUrl = url.replace(/^http:\/\//, 'https://')
  if (normalizedUrl.includes('platform195')) {
    return buildImgSrcForPlatform195(normalizedUrl, width, height)
  }
  if (imageOrigin === ImageOrigin.CMSSitecore) {
    return buildImgSrcForCMSSitecore(normalizedUrl, width, height)
  }
  return buildImgSrcForMediaServer(normalizedUrl, width, height)
}

export function buildImgSrcSet(url: string, widths: number[], imageOrigin: ImageOrigin = ImageOrigin.MediaServer) {
  return widths
    .map((width) => {
      return `${buildImgSrc(url, width, undefined, imageOrigin)} ${width}w`
    })
    .join(', ')
}

function buildImgSrcForMediaServer(url: string, width: number, height?: number) {
  if (url.includes('&mode=') || url.includes('&scale='))
    return url
  if (height) {
    return `${url}?width=${width}&height=${height}&mode=crop&scale=both`
  }

  return `${url}?width=${width}&mode=crop&scale=both`
}

function buildImgSrcForCMSSitecore(url: string, width: number, height?: number) {
  if (height) {
    return `${url}?dw=${width}&dh=${height}`
  }

  return `${url}?dw=${width}`
}

function buildImgSrcForPlatform195(url: string, width: number, height?: number) {
  const urlObj = new URL(url)
  urlObj.searchParams.set('w', width.toString())
  if (height) {
    urlObj.searchParams.set('h', height.toString())
  }
  else {
    urlObj.searchParams.delete('h')
  }
  return urlObj.toString()
}
